import { YmarketReconcileDialog } from '@/components/views/dialogs/YmarketReconcileDialog'
import type { InventoryFilters } from '@/lib/api/client/inventory'
import type { InventoryListItem } from '@/lib/api/schemas/inventory.schema'
import type { SelectionAction } from '@/lib/views/actions'

function isListedOnYmarket(row: InventoryListItem): boolean {
  return (row.storefrontPrices ?? []).some((price) => price.target === 'ymarket' && price.listed)
    || (row.ymarketEconomics !== null && row.ymarketEconomics !== undefined)
}

export const YMARKET_RECONCILE_SELECTION_ACTION: SelectionAction<'inventory', InventoryListItem, InventoryFilters, 'ymarket_reconcile'> = {
  key: 'ymarket_reconcile',
  grain: 'inventory',
  label: 'Сверить цены',
  eligible: (row) => isListedOnYmarket(row)
    ? { ok: true }
    : { ok: false, reason: 'Не опубликовано на Яндекс Маркете' },
  Dialog: YmarketReconcileDialog,
}
